import { render, staticRenderFns } from "./DaCourse.vue?vue&type=template&id=3aac12d2&"
import script from "./DaCourse.vue?vue&type=script&lang=js&"
export * from "./DaCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports